// Interfaces
import { IBaseForm, IFormGeneratorInput, IFormGeneratorInputMap } from 'interfaces/form'

/**
 * @description Set select option list
 *
 * @param {IBaseForm[]} fields
 * @param {IFormGeneratorInputMap[]} options
 *
 * @return {IBaseForm[]} IBaseForm[]
 */
export const formUtils_mapFields = (fields: IBaseForm[], options: IFormGeneratorInputMap[]): IBaseForm[] => {
  const findCorrectField = (field: IFormGeneratorInput, formName: string): any => {
    let populatedField: any

    options.forEach((option: IFormGeneratorInputMap) => {
      if (option.formName === formName) {
        populatedField = {
          ...field,
          ...option,
        }
      }
    })

    return populatedField
  }

  return fields.map((field: IBaseForm) => {
    if (field.isColumn) {
      return {
        ...field,
        columns: field?.columns?.map((column: any) => {
          return { ...column, input: { ...column.input, ...findCorrectField(column.input, column.input.formName) } }
        }),
      }
    } else {
      return { ...field, input: { ...field.input, ...findCorrectField(field?.input!, field?.input?.formName!) } }
    }
  })
}
